export enum CompanyIcon {
  APPLE = 'APPLE',
  MICROSOFT = 'MICROSOFT',
  RIVIAN = 'RIVIAN',
  STEELHOUSE = 'STEELHOUSE',
  SUPERGROUP = 'SUPERGROUP',
  TEKSYSTEMS = 'TEKSYSTEMS',
  UPKEEP = 'UPKEEP',
}
